import moment from 'moment'

export const isOverdueInvoice = (invoice, today = moment()) => (
  invoice.invoice_status === 'sent' &&
  Boolean(invoice.due_at) &&
  moment(invoice.due_at).isBefore(today, 'day')
)

export const isOutstandingInvoice = (invoice, today = moment()) => (
  isOverdueInvoice(invoice, today) || (
    invoice.invoice_status === 'sent' &&
    Boolean(invoice.invoice_date) &&
    moment(invoice.invoice_date).isSameOrBefore(today, 'day')
  )
)
